import React from "react";
import { reduxForm } from "redux-form";
import firebase from 'firebase';
import { callService} from "../tools";
import { servicios } from "../properties";
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';

let rutaWhatsO = '';
const opcionesAyuda = "contenedor-opcionesAyuda";

class BtnAyuda extends React.Component {

    state = {
        btnAyuda: false,
    }

    componentWillMount = () => {
        const url = new URL(`${servicios.hostBackend}/horario/whats-config/registro`);
        const requestOptions = {
			method: 'GET',
			headers: { 
			'Content-Type': 'application/json'
			},
		};
        fetch(url, requestOptions)
        .then(response => response.json())
        .then(config => {
            if (config.error) {
                console.log(config.errorMessage);
                this.setState({ btnAyuda: false });
            } else {
                this.setState({ btnAyuda: config.show });
                rutaWhatsO = config.link;
            }
        }).catch(error => {
            this.setState({ btnAyuda: false });
            console.error("Error en la configuracion de whats.", error);
        });

        setTimeout(() => {
            document.getElementsByClassName(opcionesAyuda)[0].style.display = "none";
        }, 100);
    }

    cambiarRef = () => {
        document.getElementsByClassName('opcion-whatsApp')[0].href = rutaWhatsO;
        document.getElementsByClassName('opcion-whatsApp')[1].href = rutaWhatsO;
    }

    validarHora = (data) => {
        const hoy = new Date();

        if (hoy.getDay() === 0) {
            this.setState({ btnAyuda: false });
        } else if (hoy.getDay() === 6) {
            this.horarioBtnWSab(data);
        }
        else {
            this.horarioBtnWSem(data);
        }
    }

    horarioBtnWSab = (data) => {
        const hoy = new Date();
        const horaActual = hoy.getHours();
        const minutosActual = hoy.getMinutes();
        const horaInicioFS = parseInt(data.horaInicio_FinSemana.substring(0, 2));
        const minutosInicioFS = parseInt(data.horaInicio_FinSemana.substring(3, 5));
        const horaFinFS = parseInt(data.horaFin_FinSemana.substring(0, 2));
        const minutosFinFS = parseInt(data.horaFin_FinSemana.substring(3, 5));
        if (horaActual === horaInicioFS && minutosActual >= minutosInicioFS) {

            this.setState({ btnAyuda: true });
        } else if (horaActual === horaFinFS && minutosActual <= minutosFinFS) {
            this.setState({ btnAyuda: true });
        }
        else if (horaActual > horaInicio && horaActual < horaFin) {
            this.setState({ btnAyuda: true });
        } else {
            this.setState({ btnAyuda: false });
        }
    }

    horarioBtnWSem = (data) => {
        const hoy = new Date();
        const horaActual = hoy.getHours();
        const minutosActual = hoy.getMinutes();
        const horaInicio = parseInt(data.horaInicio_Semana.substring(0, 2));
        const minutosInicio = parseInt(data.horaInicio_Semana.substring(3, 5));
        const horaFin = parseInt(data.horaFin_Semana.substring(0, 2));
        const minutosFin = parseInt(data.horaFin_Semana.substring(3, 5));


        if (horaActual === horaInicio && minutosActual >= minutosInicio) {

            this.setState({ btnAyuda: true });
        } else if (horaActual === horaFin && minutosActual <= minutosFin) {
            this.setState({ btnAyuda: true });
        }
        else if (horaActual > horaInicio && horaActual < horaFin) {
            this.setState({ btnAyuda: true });
        } else {
            this.setState({ btnAyuda: false });
        }
    }

    mostrarOpciones = () => {
        const mostrar = document.getElementsByClassName(opcionesAyuda)[0].style.cssText
        if (mostrar === 'display: none;') {
            document.getElementsByClassName(opcionesAyuda)[0].style.display = "block";
            this.cambiarRef();
        } else {
            document.getElementsByClassName(opcionesAyuda)[0].style.display = "none";

        }
    }

    render() {
        return <div className="contenedor-btnA">
            {
                this.state.btnAyuda === true ?
                    <button id="btnAyudaModal" onClick={this.mostrarOpciones} color="primary" class="btn-ayuda" >
                        <div className="contenedor-ayuda">
                            <div className="icono-interrogacion">
                                <HelpOutlineIcon
                                    style={
                                        {
                                            height: "20px",
                                            width: "30px",
                                        }
                                    }
                                ></HelpOutlineIcon>
                            </div>
                            <div className="texto-Ayuda">
                                Ayuda
                            </div>
                        </div>
                    </button>
                :
                ''
            }
        </div>;
    }
}

BtnAyuda = reduxForm({ form: "datosPassword" })(BtnAyuda);
export default (BtnAyuda);


// WEBPACK FOOTER //
// ./src/gnp-registro/btn-ayuda.cmpt.js